import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
// import CustomDateRangePicker from "components/CustomComponents/CustomDateRangePicker";
import BSDateRangePicker from "./DateRangePicker";
import { useForm } from "react-hook-form";
import { customAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  themes,
  scrollTop,
  StatusType,
  tableRowSize,
  stickyHeader,
  defaultAllSelection,
} from "services/constants";
import {
  Groups,
  GroupRemove,
  TableView,
  CreditScore,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import {
  earningShiftHeader,
  earningTypeColors,
} from "pages/PayRoll/PayRollHeaders";
import { Typography, Box, Paper } from "@mui/material";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import moment from "moment";
let showReprocessButton = true;
let selectedStartDate = "";
let selectedEndDate = "";
export const EarningShift = () => {
  const { register, handleSubmit, reset, setValue, formState } = useForm({
    mode: "onBlur",
  });
  const { errors } = formState;
  const { domain, userScreenAccess, topbarCompanyId, userDetails } =
    useSelector((state) => state.tokenReducer);
  const [departmentId, setDepartmentId] = useState(defaultAllSelection);
  const { result: membersData, setLoad: reCallMemberApi } = useFetch(
    `${domain}list/employee?company_id=${topbarCompanyId}&department_id=${departmentId}&status=Active`,
  );
  const [payscheduleDate, setPayscheduleDate] = useState("");
  const [departmentName, setDepartmentName] = useState("All");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [shiftData, setShiftData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState(defaultAllSelection);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [shiftDetails, setShiftDetails] = useState([]);
  const [showReprocessDialog, setShowReprocessDialog] = useState(false);
  const containerRef = useRef(null);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Earnings",
    "Shift",
  );
  const { result: departmentsData } = useFetch(
    `${domain}get-department/?user_id=${userDetails.id}`,
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setShiftDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage],
  );

  const callUpdatedApi = useCallback(
    async (start_date, end_date) => {
      setLoading(true);
      const res = await customGetAPI(
        `${domain}payroll/earning/shift/earning_details/?company_id=${topbarCompanyId}&start_date=${start_date}&end_date=${end_date}`,
      );
      if (res.ok) {
        setShiftData(res?.responseDetails);
        setLoading(false);
      }
    },
    [domain, topbarCompanyId],
  );

  useEffect(() => {
    if (topbarCompanyId) {
      callUpdatedApi(selectedStartDate, selectedEndDate);
    }
  }, [callUpdatedApi, topbarCompanyId]);

  const updateUserName = (event, data) => {
    if (data) {
      setUserName(data?.first_name);
      setUserId(data.user_id);
      setValue("user_id", data.user_id);
      const [day, month, year] = data.last_pay_date.split("-");
      let dateValue = `${year}-${month}-${day}`;
      setPayscheduleDate(dateValue);
    }
  };

  const validateStartDate = (value) => {
    if (!value) {
      return "Start date is required.";
    }
  };

  const validateEndDate = (value) => {
    if (!endDate) {
      return "End date is required.";
    } else if (startDate && endDate < startDate) {
      return "End date cannot be before the start date";
    }
    return true;
  };

  const handleStartDateChange = (event) => {
    const date = event.target.value;
    setStartDate(date);
    setValue("from_date", date);
  };

  const onSubmit = async (data) => {
    if (data) {
      const response = await customAPI(
        `${domain}payroll/reprocess_daily_salary/`,
        "POST",
        {
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
          user_id: userId,
        },
      );
      if (response.ok) {
        showToast(
          "success",
          "daily payrun reprocess successfully successfully",
        );
        callUpdatedApi(selectedStartDate, selectedEndDate);
        handleCancelClose();
      }
    }
  };

  const handleEndDateChange = (event) => {
    const date = event.target.value;
    setEndDate(date);
    setValue("to_date", date);
  };

  const handleCancelClose = () => {
    setShowReprocessDialog(false);
    reset();
    setStartDate(null);
    setValue("from_date", null);
    setEndDate(null);
    setValue("to_date", null);
    setUserName("");
    setUserId(null);
    setDepartmentId(defaultAllSelection);
    setDepartmentName("All");
  };

  const updateDepartmentName = (event, data) => {
    if (data) {
      setDepartmentId(data.id);
      setDepartmentName(data.label);
      reCallMemberApi(true);
    }
  };

  const getYesterday = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d.toISOString().split("T")[0]; // YYYY-MM-DD
  };

  const yesterday = getYesterday();

  const handleStartDate = async (startDateValue, endDateValue) => {
    let start_date = moment(
      new Date(startDateValue.split("/").reverse().join("-")),
    ).format("YYYY-MM-DD");
    let end_date = moment(
      new Date(endDateValue.split("/").reverse().join("-")),
    ).format("YYYY-MM-DD");
    selectedStartDate = start_date;
    selectedEndDate = end_date;
    callUpdatedApi(start_date, end_date);
  };

  const round2 = (num) => Number(num.toFixed(2));

  const sumByKey = (data, key) =>
    round2(
      data?.reduce((sum, item) => {
        if (item?.basis === "hours") return sum;
        return sum + (Number(item?.[key]) || 0);
      }, 0) ?? 0,
    );

  const timeToMinutes = (timeStr) => {
    if (!timeStr) return 0;

    const [h = 0, m = 0, s = 0] = timeStr.split(":").map(Number);
    return h * 60 + m + Math.round(s / 60);
  };

  const minutesToTimeString = (minutes = 0) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const getAverageTime = (data, timeKey) => {
    const { totalMinutes, count } = data?.reduce(
      (acc, item) => {
        if (item?.earning_type === "Absent") return acc;
        if (!item?.[timeKey]) return acc;

        acc.totalMinutes += timeToMinutes(item[timeKey]);
        acc.count += 1;
        return acc;
      },
      { totalMinutes: 0, count: 0 },
    ) ?? { totalMinutes: 0, count: 0 };

    return minutesToTimeString(count ? Math.round(totalMinutes / count) : 0);
  };

  const averageCreditShiftTime = getAverageTime(
    shiftDetails,
    "credit_shift_hours",
  );

  const averageWorkedShiftTime = getAverageTime(
    shiftDetails,
    "worked_shift_hours",
  );

  const totalPenalty = sumByKey(shiftDetails, "penalty");
  const totalCredited = sumByKey(shiftDetails, "quantity");
  const totalPayable = sumByKey(shiftDetails, "adjusted");

  const cardData = [
    {
      id: 1,
      icon: TableView,
      label: "Credited QTY",
      value: totalCredited,
      bgColor: "#F0FDFA",
      iconBgColor: "#D1FAF5",
      iconBorderColor: "#0F766E",
      iconColor: "#09BD71",
    },
    {
      id: 2,
      icon: GroupRemove,
      label: "Penalty OTY",
      value: totalPenalty,
      bgColor: "#FFF1F2",
      iconBgColor: "#FFE4E6",
      iconBorderColor: "#DC2626",
      iconColor: "#DC2626",
    },
    {
      id: 3,
      icon: Groups,
      label: "Payable QTY",
      value: totalPayable,
      bgColor: "#F5F7FF",
      iconBgColor: "#E0E7FF",
      iconBorderColor: "#1D4ED8",
      iconColor: "#1D4ED8",
    },
    {
      id: 4,
      icon: CreditScore,
      label: "Avg working hrs",
      value: averageWorkedShiftTime,
      bgColor: "#FFF1F2",
      iconBgColor: "#FFE4E6",
      iconBorderColor: "#EAAB35",
      iconColor: "#EAAB35",
    },
    {
      id: 5,
      icon: CreditScore,
      label: "Credited working hrs",
      value: averageCreditShiftTime,
      bgColor: "#F5F7FF",
      iconBgColor: "#E0E7FF",
      iconBorderColor: "#7A2DCC",
      iconColor: "#7A2DCC",
    },
  ];

  return (
    <React.Fragment>
      <ConfirmationDialog
        open={showReprocessDialog}
        onClose={handleCancelClose}
        onConfirm={handleSubmit(onSubmit)}
        title={"Daily Payroll Reprocess"}
        showChildren={true}
        cancelText="Cancel"
      >
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            {/* 40% — Employee Name label */}
            <Box sx={{ width: "40%" }}>
              <Mui.Typography sx={{ fontWeight: "bold" }}>
                Department Name
              </Mui.Typography>
            </Box>

            {/* 60% — Autocomplete */}
            <Box sx={{ width: "60%" }}>
              <CustomAutoComplete
                dataList={[
                  {
                    id: defaultAllSelection,
                    department_name: "All",
                    label: "All",
                  },
                  ...(departmentsData?.map((obj) => ({
                    ...obj,
                    label: obj.department_name,
                  })) ?? []),
                ]}
                selectedValue={departmentName}
                updateDataFunction={updateDepartmentName}
                placeHolder="Select department name"
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            {/* 40% — Employee Name label */}
            <Box sx={{ width: "40%" }}>
              <Mui.Typography sx={{ fontWeight: "bold" }}>
                Employee Name
              </Mui.Typography>
            </Box>
            {/* 60% — Autocomplete */}
            <Box sx={{ width: "60%" }}>
              <CustomAutoCompleteWithLogo
                dataList={membersData?.map((obj) => ({
                  ...obj,
                  label: obj?.first_name,
                  image: obj?.image_url,
                }))}
                selectedValue={userName}
                updateDataFunction={updateUserName}
                // placeHolder="Select employee name"
                showAvathar={showAutoCompleteAvathar}
                setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            {/* 40% — Employee Name label */}
            <Box sx={{ width: "40%" }}>
              <Mui.Typography sx={{ mb: 1, mt: 0.5, fontWeight: "bold" }}>
                Start Date&nbsp;
              </Mui.Typography>
            </Box>
            {/* 60% — Autocomplete */}
            <Box sx={{ width: "60%" }}>
              <Mui.TextField
                size="small"
                type="date"
                value={startDate}
                id="from_date"
                {...register("from_date", {
                  required: "start date is required.",
                  validate: validateStartDate,
                })}
                error={errors.from_date}
                onChange={handleStartDateChange}
                inputProps={{ min: payscheduleDate, max: yesterday }}
                helperText={errors.from_date && errors.from_date.message}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            {/* 40% — Employee Name label */}
            <Box sx={{ width: "40%" }}>
              <Mui.Typography sx={{ mb: 1, mt: 0.5, fontWeight: "bold" }}>
                End Date&nbsp;
              </Mui.Typography>
            </Box>
            {/* 60% — Autocomplete */}
            <Box sx={{ width: "60%" }}>
              <Mui.TextField
                size="small"
                type="date"
                id="to_date"
                value={endDate}
                {...register("to_date", {
                  required: "End date is required.",
                  validate: {
                    dateNotBeforeStart: validateEndDate,
                  },
                })}
                onChange={handleEndDateChange}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ min: payscheduleDate, max: yesterday }}
                error={errors.to_date}
                helperText={errors.to_date && errors.to_date.message}
                fullWidth
              />
            </Box>
          </Box>
        </form>
      </ConfirmationDialog>
      <Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left side: title */}
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Shift Earning
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Track employee earnings calculated based on completed shifts and
              assigned work hours.
            </Typography>
          </Box>

          {/* Right side: date filter */}
          <Box>
            <BSDateRangePicker
              handleStartDate={handleStartDate}
              showToday={true}
              triggerDate={true}
            />
          </Box>
        </Box>

        <Paper
          sx={{
            width: "100%",
            height: "78vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden", // important
          }}
        >
          <CustomFilter
            title="Shift Earning Records"
            filterHeaders={earningShiftHeader}
            data={shiftData}
            filteredData={shiftDetails}
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={check_access}
            showReprocessButton={showReprocessButton}
            setShowReprocessDialog={setShowReprocessDialog}
          />
          {loading ? (
            <Loader />
          ) : (
            <>
              <Box>
                <Mui.Box sx={{ flexGrow: 1, overflow: "auto", pt: 0, mb: 2 }}>
                  <Mui.Box
                    sx={{
                      paddingLeft: 3,
                      paddingRight: 3,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 4,
                      flexWrap: "wrap", // ⭐ KEY FIX
                      alignItems: "flex-start",
                    }}
                  >
                    {cardData.map((item) => {
                      const IconComponent = item.icon;
                      return (
                        <Mui.Card
                          key={item.id}
                          sx={{
                            flex: "0 0 200px",
                            width: 200,
                            height: 123,
                            minWidth: 200, // optional safety
                            minHeight: 123,
                            bgcolor: themes?.whiteColor,
                            borderRadius: 1,
                            boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                            border: `0.5px solid ${item.iconBorderColor}`,
                          }}
                        >
                          <Mui.CardContent
                            sx={{
                              p: 2,
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <Mui.Box
                              sx={{
                                width: 35,
                                height: 35,
                                bgcolor: item.iconBgColor,
                                border: `0.5px solid ${item.iconBorderColor}`,
                                borderRadius: 1,
                                boxShadow: "0px 1px 2px rgba(0,0,0,0.25)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 1.5,
                              }}
                            >
                              <IconComponent
                                width={16}
                                height={16}
                                style={{ color: item.iconColor, padding: 2 }}
                              />
                            </Mui.Box>
                            <Mui.Typography
                              variant="body1"
                              sx={{
                                fontWeight: 600,
                                mb: "auto",
                              }}
                            >
                              {item.label}
                            </Mui.Typography>
                            <Mui.Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: "#32325D",
                              }}
                            >
                              {item.value}
                            </Mui.Typography>
                          </Mui.CardContent>
                        </Mui.Card>
                      );
                    })}
                  </Mui.Box>
                </Mui.Box>
              </Box>
              <Mui.Grid
                sx={{
                  ml: 2,
                  mr: 2,
                  flex: 1, // ⭐ take remaining height
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Mui.TableContainer
                  ref={containerRef}
                  sx={{
                    flex: 1,
                    overflow: "auto",
                  }}
                >
                  <Mui.Table className="border">
                    <Mui.TableHead sx={stickyHeader}>
                      <Mui.TableRow sx={tableRowSize}>
                        {earningShiftHeader?.map((value) => (
                          <Mui.TableCell
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                            }}
                          >
                            {value?.name}
                          </Mui.TableCell>
                        ))}
                      </Mui.TableRow>
                    </Mui.TableHead>
                    <Mui.TableBody>
                      {shiftDetails?.length === 0 ? (
                        <InfoMessage dataLength={shiftData} />
                      ) : (
                        shiftDetails
                          ?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          ?.map((value) => (
                            <Mui.TableRow sx={tableRowSize}>
                              {earningShiftHeader.map((head) => (
                                <Mui.TableCell>
                                  {head.key === "earning_type" ? (
                                    <span
                                      style={StatusType(
                                        value.earning_type,
                                        earningTypeColors,
                                      )}
                                    >
                                      {value.earning_type}
                                    </span>
                                  ) : head.key === "basis" ? (
                                    (value?.basis ?? "N/A")
                                  ) : (
                                    (value[head.key] ?? "0")
                                  )}
                                </Mui.TableCell>
                              ))}
                            </Mui.TableRow>
                          ))
                      )}
                    </Mui.TableBody>
                  </Mui.Table>
                </Mui.TableContainer>
                {shiftDetails?.length > 25 && (
                  <Box sx={{ mt: 1 }}>
                    <Mui.TablePagination
                      className="custom-pagination"
                      component="div"
                      rowsPerPageOptions={[25, 50, 75, 100]}
                      count={shiftDetails?.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Box>
                )}
              </Mui.Grid>
            </>
          )}
        </Paper>
      </Box>
    </React.Fragment>
  );
};
